import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Guards the /partner/* routes.
 *
 * Requires:
 *  1. Authenticated user
 *  2. `user.partnerId` set (user is linked to a Partner)
 *
 * Admin/projectmanager users without a partnerId are redirected to the
 * regular dashboard — they should use /storingen, not the partner portal.
 */
export default function PartnerRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-sm text-gray-500">Laden…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!user?.partnerId) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
